import { useTranslation } from 'react-i18next'

import { RadioCardGroup } from '../RadioCardGroup'

type Props = Parameters<typeof RadioCardGroup>[0]

export const BooleanRadioCardGroup = ({ ...props }: Props) => {
  const { t } = useTranslation()

  const options = [
    { value: true, label: t('yes'), colProps: { xs: 24, lg: 12 } },
    { value: false, label: t('no'), colProps: { xs: 24, lg: 12 } }
  ]

  return <RadioCardGroup options={options} {...props} />
}
